import { useVersionCheck } from '../hooks/useVersionCheck';

/**
 * Component that handles automatic app updates.
 * Uses version checking to detect new deployments and auto-reloads
 * when the user returns to the tab after an update.
 *
 * Mount this at the app root level.
 */
function AutoReload() {
  useVersionCheck();
  return null; // This component renders nothing
}

export default AutoReload;
